// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { WizardDeviceStepsEnum } from "./Shared.WizardDeviceStepsEnum.gen";

export interface IUpdateWizardStepRequest {
	organizationId: string | undefined;

	step: WizardDeviceStepsEnum;

	facilityGroupId: string | undefined;

	facilityId: string | undefined;

	deviceId: string | undefined;

	$type?: string | undefined;
}
export class UpdateWizardStepRequest {
	constructor(data?: IUpdateWizardStepRequest) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	organizationId: string | undefined;

	step: WizardDeviceStepsEnum = 0;

	facilityGroupId: string | undefined;

	facilityId: string | undefined;

	deviceId: string | undefined;

	static $type: string = "Shared.Models.Api.v1.Wizard.UpdateWizardStepRequest, ";
	$type?: string | undefined = UpdateWizardStepRequest.$type;
}

